import { type Model, Modelling } from "@/lib/models"

export namespace Practitioners {
  export type PractitionerAttributes = {
    state: string
    description: string | null
    designation?: string
    name: string
    practitioner_type: string
    profile_picture: string | null
    stripe_merchant_identifier?: string
  }

  export const PractitionerAttributesModel: Model<
    `PractitionerAttributes`
  > = () => {
    // FIXME: remove fields the front end doesn't use, eg state?
    return {
      state: [`string`],
      description: [`string`, null],
      designation: [`string`, undefined],
      name: `string`,
      practitioner_type: `string`,
      profile_picture: [`string`, null],
      stripe_merchant_identifier: [`string`, undefined],
    }
  }

  export type Practitioner = {
    id: string
    type: `practitioner`
    attributes: PractitionerAttributes
  }

  export const PractitionerModel: Model<`Practitioner`> = () => {
    return {
      id: `string`,
      type: Modelling.equality(`item`, `practitioner`),
      attributes: `PractitionerAttributes`,
    }
  }
}
